module.exports = __webpack_public_path__ + "static/img/logo_head1.4ee0399.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo_head1.jpg
// module id = 0UIw
// module chunks = 1